// 22.01.19 - Used by form_wrapper.tsx to show the tollbar actions.
import { StaticButtonToolbar } from "../common/button_toolbar";
import { UserRoles, CaseType, ClaimStatus } from "src/constants/api";
import { submit } from "redux-form";
import * as React from "react";
import {
  newCase,
  navigateHome,
  navigatePrint,
  updateCase,
  caseLockUnlock,
  requestForClose,
} from "src/actions/detail";
import { withStyles } from "@material-ui/core";
import { toolbarStyles } from "src/styles/general";
import { openConfirmDialog } from "../../actions/common";
import { CDK_APPROVE, CDK_CLOSE_BTN } from "../../constants/data.js";

// This component simple uses the `StaticToolbar` component we made
// to render the toolbar for the forms -- buttons for saving/updating case, and so on
// @ts-ignore
const FormToolbar = (props: any) => {
  const btnTitle = props.isNewCase ? "Submit case" : "Update case";
  const btnSubmitUpdate = { title: btnTitle, actions: [submit("mainForm")] };
  const dialogClose = {
    open: true,
    title: "Confirmation",
    content:
      "Changes that you made will not be saved if you close the case. To save your changes, please press CANCEL to return to the case and then click UPDATE CASE. Otherwise, press OK to close the case.",
    key: CDK_CLOSE_BTN,
  };
  if (props.isNewCase) {
    const btnCancel = {
      title: "Cancel",
      destructive: true,
      actions: [newCase(), navigateHome()],
    };
    return <StaticButtonToolbar actions={[btnSubmitUpdate, btnCancel]} />;
  } else {
    const { classes, roleId, allowEdit, currentUser, isLockForEdit } = props;
    if (props.caseData) {
      const isComplaintClosed =
        props.caseData &&
        props.caseData.caseType === CaseType.Complaint &&
        props.caseData.complaintStatus === false
          ? true
          : false;
      const isClaimClosed =
        props.caseData &&
        props.caseData.caseType === CaseType.Claim &&
        props.caseData.claimStatus === ClaimStatus.Closed
          ? true
          : false;
      const isComplaintClaimClosed =
        props.caseData &&
        props.caseData.caseType === CaseType.ComplaintClaim &&
        props.caseData.claimStatus === ClaimStatus.Closed &&
        props.caseData.complaintStatus === false
          ? true
          : false;
      const username = currentUser ? currentUser.userName : "";

      // Define action buttons
      const actionsCloseBtn = allowEdit
        ? [openConfirmDialog(dialogClose)]
        : [newCase(), navigateHome()];
      const btnClose = {
        title: "Close",
        destructive: true,
        actions: actionsCloseBtn,
      };
      const btnPrint = { title: "Print", actions: [navigatePrint()] };
      const btnReopen = {
        title: "Reopen",
        actions: [updateCase(props.caseData, true)],
      };
      const btnEdit = {
        title: "Edit",
        actions: [caseLockUnlock(props.caseData.uniqueId, username)],
      };
      const btnUnlockCase = {
        title: "Unlock Case",
        actions: [caseLockUnlock(props.caseData.uniqueId, -2)],
        btnClasses: "btn-green btn-right",
      };

      const dialogApprove = {
        open: true,
        title: "Confirmation",
        content:
          "Once approved, the Requestor will not be able to update the case. Please confirm?",
        key: CDK_APPROVE,
      };
      const btnApprove = {
        title: "Approve",
        actions: [openConfirmDialog(dialogApprove)],
        btnClasses: "btn-green",
      };
      const btnRequestForClosure = {
        title: "Request for Closure",
        actions: [requestForClose(props.caseData, props.currentUser)],
        btnClasses: "btn-green btn-right",
      };

      switch (roleId) {
        case UserRoles.Admin: {
          if (isComplaintClosed || isClaimClosed || isComplaintClaimClosed) {
            return (
              <StaticButtonToolbar actions={[btnClose, btnPrint, btnReopen]} />
            );
          } else if (props.isCheckOutByDiffUser) {
            return (
              <StaticButtonToolbar
                actions={[btnEdit, btnUnlockCase, btnClose, btnPrint]}
              />
            );
          } else if (allowEdit) {
            // Case is Approved
            if (isLockForEdit) {
              return (
                <StaticButtonToolbar
                  actions={[btnSubmitUpdate, btnClose, btnPrint]}
                />
              );
            } else {
              // Case Not Approved
              return (
                <StaticButtonToolbar
                  actions={[btnSubmitUpdate, btnClose, btnPrint, btnApprove]}
                />
              );
            }
          } else {
            return (
              <StaticButtonToolbar actions={[btnEdit, btnClose, btnPrint]} />
            );
          }
        }
        case UserRoles.QMU: {
          if (isComplaintClosed || isClaimClosed || isComplaintClaimClosed) {
            return (
              <StaticButtonToolbar actions={[btnClose, btnPrint, btnReopen]} />
            );
          } else if (props.isCheckOutByDiffUser) {
            return (
              <StaticButtonToolbar
                actions={[btnEdit, btnUnlockCase, btnClose, btnPrint]}
              />
            );
          } else if (allowEdit) {
            // Case is Approved
            if (isLockForEdit) {
              return (
                <StaticButtonToolbar
                  actions={[btnSubmitUpdate, btnClose, btnPrint]}
                />
              );
            } else {
              // Case Not Approved
              return (
                <StaticButtonToolbar
                  actions={[btnSubmitUpdate, btnClose, btnPrint, btnApprove]}
                />
              );
            }
          } else {
            return (
              <StaticButtonToolbar actions={[btnEdit, btnClose, btnPrint]} />
            );
          }
        }
        case UserRoles.INS: {
          if (isComplaintClosed || isClaimClosed || isComplaintClaimClosed) {
            return (
              <StaticButtonToolbar actions={[btnClose, btnPrint, btnReopen]} />
            );
          } else if (props.isCheckOutByDiffUser) {
            return (
              <StaticButtonToolbar
                actions={[btnEdit, btnUnlockCase, btnClose, btnPrint]}
              />
            );
          } else if (allowEdit) {
            // Case is Approved
            if (isLockForEdit) {
              return (
                <StaticButtonToolbar
                  actions={[btnSubmitUpdate, btnClose, btnPrint]}
                />
              );
            } else {
              // Case Not Approved
              return (
                <StaticButtonToolbar
                  actions={[btnSubmitUpdate, btnClose, btnPrint, btnApprove]}
                />
              );
            }
          } else {
            return (
              <StaticButtonToolbar actions={[btnEdit, btnClose, btnPrint]} />
            );
          }
        }
        case UserRoles.Partner: {
          return (
            <div className={classes.staticToolbarContainer}>
              <input type="hidden" />{" "}
            </div>
          );
        }
        case UserRoles.FMC: {
          return (
            <div className={classes.staticToolbarContainer}>
              <input type="hidden" />{" "}
            </div>
          );
        }
        case UserRoles.UNICEF: {
          // case closed/case approved
          if (isComplaintClosed || isClaimClosed || isComplaintClaimClosed) {
            return <StaticButtonToolbar actions={[btnClose]} />;
          }
          // Case Approved
          else if (isLockForEdit) {
            return <StaticButtonToolbar actions={[btnClose]} />;
          } else {
            if (allowEdit) {
              return (
                <StaticButtonToolbar actions={[btnSubmitUpdate, btnClose]} />
              );
            } else {
              return <StaticButtonToolbar actions={[btnEdit, btnClose]} />;
            }
          }
        }
        case UserRoles.Solution_Owner: {
          if (isComplaintClosed || isClaimClosed || isComplaintClaimClosed) {
            return <StaticButtonToolbar actions={[btnClose]} />;
          } else if (isLockForEdit) {
            // Case is approved
            // Case Unlock
            if (allowEdit) {
              if (props.isCurrentUserSO) {
                return (
                  <StaticButtonToolbar
                    actions={[btnSubmitUpdate, btnClose, btnRequestForClosure]}
                  />
                );
              } else {
                return <StaticButtonToolbar actions={[btnClose]} />;
              }
            } else {
              // Case Lock
              if (props.isCurrentUserSO) {
                return (
                  <StaticButtonToolbar
                    actions={[btnEdit, btnClose, btnRequestForClosure]}
                  />
                );
              } else {
                return <StaticButtonToolbar actions={[btnClose]} />;
              }
            }
          } else {
            // Case is not approved
            // Case Unlock
            if (allowEdit) {
              if (props.isCurrentUserSO) {
                return (
                  <StaticButtonToolbar
                    actions={[btnSubmitUpdate, btnClose, btnRequestForClosure]}
                  />
                );
              } else {
                return (
                  <StaticButtonToolbar actions={[btnSubmitUpdate, btnClose]} />
                );
              }
            } else {
              // Case Lock
              if (props.isCurrentUserSO) {
                return (
                  <StaticButtonToolbar
                    actions={[btnEdit, btnClose, btnRequestForClosure]}
                  />
                );
              } else {
                return <StaticButtonToolbar actions={[btnEdit, btnClose]} />;
              }
            }
          }
        }
        case UserRoles.Solution_Team: {
          if (isComplaintClosed || isClaimClosed || isComplaintClaimClosed) {
            return <StaticButtonToolbar actions={[btnClose]} />;
          } else if (isLockForEdit) {
            // Case is approved
            // Case Unlock
            if (allowEdit) {
              if (props.isCurrentUserSO) {
                return (
                  <StaticButtonToolbar
                    actions={[btnSubmitUpdate, btnClose, btnRequestForClosure]}
                  />
                );
              } else {
                return <StaticButtonToolbar actions={[btnClose]} />;
              }
            } else {
              // Case Lock
              if (props.isCurrentUserSO) {
                return (
                  <StaticButtonToolbar
                    actions={[btnEdit, btnClose, btnRequestForClosure]}
                  />
                );
              } else {
                return <StaticButtonToolbar actions={[btnClose]} />;
              }
            }
          } else {
            // Case is not approved
            // Case Unlock
            if (allowEdit) {
              if (props.isCurrentUserSO) {
                return (
                  <StaticButtonToolbar
                    actions={[btnSubmitUpdate, btnClose, btnRequestForClosure]}
                  />
                );
              } else {
                return (
                  <StaticButtonToolbar actions={[btnSubmitUpdate, btnClose]} />
                );
              }
            } else {
              // Case Lock
              if (props.isCurrentUserSO) {
                return (
                  <StaticButtonToolbar
                    actions={[btnEdit, btnClose, btnRequestForClosure]}
                  />
                );
              } else {
                return <StaticButtonToolbar actions={[btnEdit, btnClose]} />;
              }
            }
          }
        }
        default:
          return <StaticButtonToolbar actions={[btnClose]} />;
      }
    } else {
      return null;
    }
  }
};

export default withStyles(toolbarStyles)(FormToolbar);
